import get from 'lodash/get';
import store from '@Store';
import MessageBroker from '@Services/MessageBroker';
import RequestUrls from '@Constants/RequestUrlsConstants';

import {
  FETCH_CAS_NUMBER,
  FETCH_CAS_NUMBER_SUCCESS,
  FETCH_CAS_NUMBER_FAILURE,
  ADD_CAS_NUMBER_FOR_RESULT_NAME,
  CLEAR_CAS_NUMBERS,
  ErrorNumbers,
} from '@Containers/CasNumber/constants';
import { isAPIError } from '@Containers/CasNumber/utils';
import { showCasNumberErrorToastMessage } from '@Containers/CasNumber/CasNumberErrorToastMessage';
import { onFetchCasNumber, onFetchCasNumberSuccess, onFetchCasNumberError } from '@Containers/CasNumber/analytics';

export const fetchCasNumber =
  ({ structure, name, inChiKey, substanceId, databaseId, withCta }) =>
  async (dispatch) => {
    dispatch({
      type: FETCH_CAS_NUMBER,
      payload: { databaseId, substanceId },
    });
    onFetchCasNumber({ substanceId, databaseId, withCta });

    try {
      const response = await MessageBroker.send(RequestUrls.casSearch, {
        structure,
        name,
        inChiKey,
        substanceId,
        databaseId,
      });
      const casNumber = get(response, ['casRn']);

      dispatch({
        type: FETCH_CAS_NUMBER_SUCCESS,
        payload: { databaseId, substanceId, casNumber },
      });
      onFetchCasNumberSuccess({ substanceId, databaseId, withCta, casNumber });
    } catch (error) {
      const errorNumber = get(error, ['errorNumber'], ErrorNumbers.UNKNOWN_EXCEPTION);
      const errorMessage = get(error, ['message']);

      if (isAPIError(errorNumber)) {
        showCasNumberErrorToastMessage();
      }

      dispatch({
        type: FETCH_CAS_NUMBER_FAILURE,
        payload: { databaseId, substanceId, errorNumber },
      });
      onFetchCasNumberError({
        substanceId,
        databaseId,
        withCta,
        errorNumber,
        errorMessage,
      });
    }
  };

export const addCasNumberForResultName = ({ resultName, casNumber }) => ({
  type: ADD_CAS_NUMBER_FOR_RESULT_NAME,
  payload: { resultName, casNumber },
});

export const clearCasNumbers = () => ({
  type: CLEAR_CAS_NUMBERS,
});

export const dispatchClearCasNumbers = () => store.dispatch(clearCasNumbers());

export const updateCasNumberFromSearchPayload = ({ casRn, resultSize, resultName } = {}) => {
  if (casRn && resultSize) {
    store.dispatch(addCasNumberForResultName({ resultName, casNumber: casRn }));
  }
};

export const checkCasNumberSearchErrorPayload = ({ errorNumber } = {}) => {
  if (isAPIError(errorNumber)) {
    showCasNumberErrorToastMessage();
  }
};
